module.exports = __webpack_public_path__ + "media/images/folder_icon-3400054982a0cd857a8a38a3abc987a9.svg";